/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { CheckSumsHistoryDto } from '../../../api/cashBoxes/cashBoxesClient.typings';
import {
    CashBoxCheckSumsTabAction,
    CashBoxCheckSumsTabActionType,
} from '../../../actions/CashBoxRegistry/Tabs/cashBoxCheckSumsTabActions';

export interface CashBoxCheckSumsTabState {
    checkSumsHistory: CheckSumsHistoryDto;
    isLoadingCheckSumsHistory: boolean;
}
const initialState: CashBoxCheckSumsTabState = {
    checkSumsHistory: null,
    isLoadingCheckSumsHistory: false,
};

export function cashBoxCheckSumsTabReducer(
    state: CashBoxCheckSumsTabState = initialState,
    action: CashBoxCheckSumsTabAction,
): CashBoxCheckSumsTabState {
    switch (action.type) {
        case CashBoxCheckSumsTabActionType.FETCH_CHECKSUMS_HISTORY:
            return {
                ...state,
                isLoadingCheckSumsHistory: true,
            };

        case CashBoxCheckSumsTabActionType.FETCH_CHECKSUMS_HISTORY_SUCCESS:
            return {
                ...state,
                checkSumsHistory: action.payload,
                isLoadingCheckSumsHistory: false,
            };

        case CashBoxCheckSumsTabActionType.FETCH_CHECKSUMS_HISTORY_ERROR:
            return {
                ...state,
                isLoadingCheckSumsHistory: false,
                checkSumsHistory: {
                    count: 0,
                    items: [],
                },
            };

        case CashBoxCheckSumsTabActionType.EXIT_CASHBOX_CHECKSUMS_TAB:
            return {
                ...state,
                checkSumsHistory: null,
            };

        default:
            break;
    }
    return state;
}
